import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import categoriesReducer from './slices/categoriesSlice';
import productsReducer from './slices/productsSlice';
import ordersReducer from './slices/ordersSlice';
import usersReducer from './slices/usersSlice';
import groupsReducer from './slices/groupsSlice';
import settingsReducer from './slices/settingsSlice';
import privacyPolicyReducer from './slices/privacyPolicySlice';
import bannerReducer from './slices/bannerSlice';
import productMasterReducer from './slices/productMasterSlice';
import dashboardReducer from './slices/dashboardSlice';
import faqsReducer from './slices/faqsSlice';
import aboutUsReducer from './slices/aboutUsSlice';
import termsAndConditionsReducer from './slices/termsandconditionSlice';
import groupAgentsReducer from './slices/groupagentsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    categories: categoriesReducer,
    products: productsReducer,
    orders: ordersReducer,
    users: usersReducer,
    groups: groupsReducer,
    settings: settingsReducer,
    privacyPolicy: privacyPolicyReducer,
    banner: bannerReducer,
    productMaster: productMasterReducer,
    dashboard: dashboardReducer,
    faqs: faqsReducer,
    aboutUs: aboutUsReducer,
    terms: termsAndConditionsReducer,  
    groupAgents: groupAgentsReducer
  },
  // devTools : true
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;